import { GetCatalogSearchScopeArgs } from 'types/api/arguments/get-catalog-search-scope-args'
import { GetCatalogSearchScopeResp } from 'types/api/response/get-catalog-search-scope-resp'

import { api } from './api'

export const getCatalogSearchScope = (args: GetCatalogSearchScopeArgs) =>
  api.get<GetCatalogSearchScopeResp>('/catalog/search_scope', {
    params: {
      search_text: args.searchText,
      catalog_id: args.catalogId,
      search_start_type: args.search_start_type,
      search_start_id: args.search_start_id,
    },
  })
